module.exports = __webpack_public_path__ + "img/Soncraft_logo.29ef3fae.png";